/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : cart-details-actions.ts
 *
 * Project Title : Checkout
 *
 * Description   : Initial version
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       :  Sivateja (H267743)
 *
 * @Date         : AUG 2, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : Sivateja (H267743)
 * On            : Aug 14, 2019
 * Description   : Integrated save to cart , get cart details servcies , updated respective actions(ASDS-909)
 *
 * By            : H352615
 * On            : Aug 26, 2019
 * Description   : Updated code as ASDS-1084.
 *
 * By            : H352615
 * On            : Aug 27, 2019
 * Description   : Add Loader for fetching features - ASDS-1084
 * By            : Avanthi G (E860178)
 * On            : Sep 06, 2019
 * Description   : Sending Dymanic UserID for fetching mycart details service and add to cart service(ASDS-1173)
 *
 * By            : Sivateja (H267743)
 * On            : Aug 14, 2019
 * Description   : showing error message if scm serial number present in the cart(ASDS-1048)
 *
 * By            : Sivateja (H267743)
 * On            : Sept 19, 2019
 * Description   : Added actions for edit buttons in confirm-configuration tab (ASDS-1047)
 *
 * By            : Deepthi Bachu (E844276)
 * On            : Sep 18, 2019
 * Description   : Updated the code to get products features list from ADS (ASDS-1283)
 *
 * By            : H224423
 * On            : Sep 25, 2019
 * Description   : ASDS-411 Edit cart Item Aspire changes
 *
 * By            : H224423
 * On            : Sep 30, 2019
 * Description   : ASDS-412 Edit cart details changes
 *
 * By            : SandeepRaja (E807238)
 * On            : Oct 9, 2019
 * Description   : ASDS-594: Bulk Configuration - Confirm Configuration
 *					- UI (Static)
 *
 * By            : Madhu Gali - H175591
 * On            : 18 Oct 2019
 * Description   : ASDS-1549
 *
 * By            : H224423
 * On            : 24 Oct 2019
 * Description   : ASDS-1256
 *
 * By            : E860178
 * On            : Oct 24, 2019
 * Description   : Category Name added to Save cart details - ASDS-1598
 * By            : E860178
 * On            : Oct 24, 2019
 * Description   : ASDS-1578
 *
 * By            : E807238
 * On            : Nov 1, 2019
 * Description   : ASDS-1673: Add To Cart Conformation UI & Integration
 *
 * By            : H175591
 * On            : 01 Nov 2019
 * Description   : ASDS-588
 *
 * By            : Deepthi Bachu (E844276)
 * On            : Nov 14, 2019
 * Description   : ASDS-1805 changes.
 *
 * By            : E844276
 * On            : Nov 18, 2019
 * Description   : Added generic product functionalities - removed from products
 *
 * By            : H224423
 * On            : 25 Nov 2019
 * Description   : Added bulk upload validation error message.
 *
 * By            	: Madhu Gali
 * On            	: Dec 18, 2019
 * Description      : ASDS-584
 *
 * By            : Deepthi Bachu (E844276)
 * On            : Jan 9th, 2020
 * Description   : updated the code for ASDS-1081
 *
 * By            : Deepthi Bachu - E844276
 * On            : 06 Feb, 2020
 * Description   : ASDS-1957 - ASPIRE - Add To Cart - Block Adding Serial Number if already in Cart
 *
 * By            : Deepthi Bachu (E844276)
 * On            : Feb 17th, 2020
 * Description   : updated the code Product Test cases - removed unused code
 *
 * By            : E844276
 * On            : Feb 27 2020
 * Description   : Aspire - On features service failure - stop loader - ASDS-2345
 *
 * By            : H224423
 * On            : Apr 03 2020
 * Description   : ASDS-2190 - API error handling changes
 *
 * By            : H224423
 * On            : 09 Apr, 2020
 * Description   : ASDS-2497 APU SIT Fixes.
 *
 * By            : H422336
 * On            : Oct 9, 2020
 * Description   : ASDS - 3259 UI Enhancements for Phase - II
 *
 * By            : H422335
 * On            : 14 Oct 2020
 * Description   : ASDS-3035 Migration of DCE Endpoints to new Forge Environment API
 *
 * By            : H422337
 * On            : 03 Nov 2020
 * Description   : ASDS-3823 - Migration of DCE Endpoints to new Forge Environment API and UI enhancements of Phase-2
 *
 * By            : H422337
 * On            : Nov 04, 2020
 * Description   : ASDS-3570 - UI Enhancements for Phase - II  with Forge API changes
 *
 * By            : H422337
 * On            : Nov 04, 2020
 * Description   : ASDS-3572,ASDS-3573 Enhancements of phase-2 - Edit Aspire product changes
 *
 * By            : H422337
 * On            : 03 Nov 2020
 * Description   : ASDS-3824 - Migration of DCE Endpoints to new Forge Environment API and UI enhancements of Phase-2
 *
 * By            : H422337
 * On            : Nov 19, 2020
 * Description   : ASDS -4084 -UI Enhancements for Phase - II  bug fix -Error should not be displayed in the step 1 of product configuration
 *
 ******************************************************************************/
import Action from './Action';
import ActionConstants from '../action-constants';
import ConfigureProductAPI from '../../API/configureProductAPI';
import CartDetailsActions from './cart-details-actions';
import CheckoutConstants from './../../constants/checkout-constants';
import routeConstants from 'modules/checkout/constants/route-constants';
import OrderSummaryActions from './order-summary-actions';
import { logError } from '../../../../utils/console-utility';
import ProductAlertActions from './products-alerts-action';
import CartDetails from '../../API/cart-detials-api';

// serila number validation functions.
const required = fieldValue =>
  ('' + fieldValue).length > 0
    ? ''
    : 'Please add a valid serial no.';
const onlyDigits = fieldValue =>
  isNaN(fieldValue) ? 'Please add a valid serial no.' : "";
const minlenght = minLength => filedValue =>
  ('' + filedValue).length === minLength
    ? ''
    : 'Please add a valid serial no.';
const indexOfAll = (arr, val) =>
  arr.reduce((acc, el, i) => (el === val ? [...acc, i] : acc), []);
// below function will check the given serial number is present in the given serila numbers (ASDS-1048)
const presentInCart = cartSerials => serialNumber =>
  cartSerials.indexOf(serialNumber) > -1
    ? 'This serialNumber is already configured and added in the cart.' +
      ' Please enter new serial number to move ahead (or) modify the existing product in your cart. '
    : '';

const validateSCMSerials = function(serialNumberObjs: any, validations: any) {
  // function to validate the SCM serial numbers
  const errorMsg =
    'Serial Number already added. Please enter a new serial number.';
  const serialNumbers = serialNumberObjs.map(obj => {
    // get array of serials
    return obj.serialNumber;
  });

  const validatedSerials = serialNumbers.map(serial => {
    const indexes = indexOfAll(serialNumbers, serial);
    if (indexes.length > 1) {
      // check of the duplicates, if found update the error msg.
      return { serialNumber: serial, error: errorMsg };
    } else {
      // if the element does not have any duplicates
      let errorMessage;
      for (let validation of validations) {
        // check other validations like required, onlyDigits..
        errorMessage = validation(serial);
        if (errorMessage) {
          // if error found break, no need to execute the other validation funcions.
          break;
        }
      }
      return { serialNumber: serial, error: errorMessage };
    }
  });
  const errors = validatedSerials.filter(obj => {
    return obj.error.length > 0;
  });
  const hasErrors = errors.length > 0; // returns true if there is any error msg present in validated serialia numbers array.
  return { validatedSerials, hasErrors };
};

const validateFeatures = function(features: any, validateFields: any) {
  const errorMsg =
    'Part number already added. Please select a new part number.';
  const partNumbers = features.map(feature => {
    return feature.partNumber;
  });
  const validatedFeatures = features.map(feature => {
    const indexes = indexOfAll(partNumbers, feature.partNumber);
    if (indexes.length > 1) {
      // check of the duplicates, if found update the error msg.
      return { ...feature, partNumberError: errorMsg };
    } else {
      if (feature.partNumber) {
        if (validateFields.indexOf('validity') > -1) {
          if (feature.validity) {
            return { ...feature, partNumberError: '', validityError: '' };
          } else {
            return {
              ...feature,
              partNumberError: '',
              validityError: 'Please Select validity'
            };
          }
        } else {
          return { ...feature, partNumberError: '', validityError: '' };
        }
      } else {
        return {
          ...feature,
          partNumberError: 'Please Select part number',
          validityError: ''
        };
      }
    }
  });
  const errors = validatedFeatures.filter(feature => {
    return (
      feature.partNumberError.length > 0 ||
      feature.validityError.length > 0 ||
      !feature.validity
    );
  });
  const hasErrors = errors.length > 0; // returns true if there is any error msg present in validated array
  return { validatedFeatures, hasErrors };
};

/**
 * This takes the individial product details and prepares the Object to for saveToCart API and editCart API
 * @param productDetails
 */
const saveToCartObjMapper = function(productDetails: any, opType: string,  soldTo: any) {
  const subProducts: any = [];

  productDetails.serialNumbers.map(serialObj => {
    productDetails.subProducts.map(product => {
      subProducts.push({
        partNumber: product.partNumber,
        featureName: product.subProductName,
        featureId: product.subProductId,
        featureDesc: product.subProductDesc,
        validity: product.validity,
        unitPrice: parseFloat(product.unitPrice),
        serialNo: serialObj.serialNumber,
        soldTo: soldTo,
        discountPrice: parseFloat(product.discountedPrice),
        discountPercentage: parseFloat(product.discountPercentage),
        prodSeq : product.productSeq,
        seq: product.seq
      });
    });
  });
  let cartObjToAdd: any;
  if (opType === CheckoutConstants.OPERATION_TYPE_SAVE) {
    cartObjToAdd = {
    cart: {
    product: {
        aspire: subProducts,
        prodDesc: productDetails.productDesc,
        prodId: productDetails.productId,
        prodName: productDetails.productName,
        system: productDetails.system,
        categoryName: productDetails.categoryName,
      }
  }
}
}
else {
  cartObjToAdd = {
    cart: {
      cartSeq: productDetails.cartSeq,
      seq: productDetails.seq,
    product: {
      id: productDetails.id,
        aspire: subProducts,
        prodDesc: productDetails.productDesc,
        prodId: productDetails.productId,
        prodName: productDetails.productName,
        system: productDetails.system,
        categoryName: productDetails.categoryName,
      }
  }
}
}
return cartObjToAdd;

};

class ConfigureProductActions extends Action {
  static getFeaturesMasterData(productId: string) {
    return (dispatch, getState) => {
      dispatch({
        type: ActionConstants.GET_PRODUCT_FEATURES,
        payload: {
          isFeatureMasterDataFetching: true
        }
      });

      const soldTo = getState().selectAccount.selectAccountDetails.payload
        .soldTo.sapNumber;

      ConfigureProductAPI.getProductFeatureList(productId, soldTo)
        .then(response => {
          dispatch({
            type: ActionConstants.GET_PRODUCT_FEATURES,
            payload: {
              isFeatureMasterDataFetching: false
            }
          });

          dispatch({
            type: ActionConstants.SET_PRODUCT_FEATURES,
            payload: {
              response: response.subProducts
            }
          });
        })
        .catch(error => {
          dispatch({
            type: ActionConstants.GET_PRODUCT_FEATURES,
            payload: {
              isFeatureMasterDataFetching: false
            }
          });

          logError('Error fetching and parsing features response', error);
        });
    };
  }

  // this function will delete the feature at given index.
  static deleteFeature( selectedRows: any) {
    return (dispatch, getState) => {
      let previousFeatures = getState().configProductData.payload
        .productFeatures;
      const serialsCount = getState().configProductData.payload.serialNumbers
        .length;
      if (previousFeatures.length >= 1) {
        // don't remove the firtst feature.
        // let featuresCopy = [...previousFeatures];
        // featuresCopy.splice(index, 1);
        previousFeatures = previousFeatures.filter((obj) => {
              const indexFromSelectedRowData = selectedRows.findIndex((x: any) => (x.partNumber === obj.partNumber));
              let returnFilterObj;
              if (indexFromSelectedRowData === -1) {
                  returnFilterObj = obj;
              }
              return returnFilterObj;
          });



        let updatedProductData;
        let enableNextBtn;
        if (previousFeatures.length !== 0){
        const validateFields = ['partNumber', 'validity']; // tells what are the fileds that needs to be valiated
        const { validatedFeatures, hasErrors } = validateFeatures(
          previousFeatures,
          validateFields
        );
        updatedProductData = [...validatedFeatures];
        enableNextBtn = !hasErrors;
        }
        else {
          const newFeature = {
            partNumber: '',
            validity: '',
            unitPrice: '0.00',
            extendedPrice: '0.00',
            partNumberError: '',
            validityError: ''
          };
          updatedProductData = [...previousFeatures, newFeature];
              enableNextBtn = false;
        }
        const totalPrice = ConfigureProductActions.updateTotalPrice(
          updatedProductData,
          serialsCount
        );
        dispatch({
          type: ActionConstants.DELETE_FEATURE,
          payload: {
            featuresCopy: updatedProductData,
            totalPrice,
            enableNextBtn: enableNextBtn
          }
        });

      }
    };
  }

  /**
   *
   * @returns {(dispatch, getState) => void}
   */
  static addNewFeature() {
    const newFeature = {
      partNumber: '',
      validity: '',
      unitPrice: '0.00',
      extendedPrice: '0.00',
      partNumberError: '',
      validityError: ''
    };
    return (dispatch, getState) => {
      const previousFeatures = getState().configProductData.payload
        .productFeatures;
      let newProductFeatures;
      const validateFields = ['partNumber', 'validity']; // tells what are the fileds that needs to be valiated
      const { validatedFeatures, hasErrors } = validateFeatures(
        previousFeatures,
        validateFields
      );
      if (hasErrors) {
        newProductFeatures = [...validatedFeatures];
      } else {
        newProductFeatures = [...previousFeatures, newFeature];
      }

      dispatch({
        type: ActionConstants.ADD_NEW_FEATURE,
        payload: {
          newProductFeatures,
          enableNextBtn: false
        }
      });
    };
  }

  static updateFeature(feature, index) {
    return (dispatch, getState) => {
      const previousFeatures = getState().configProductData.payload
        .productFeatures;
      const serialsCount = getState().configProductData.payload.serialNumbers
        .length;
      const features = [...previousFeatures];
      features[index].partNumber = feature.partNumber;
      features[index].subProductName = feature.subProductName;
      features[index].subProductDesc = feature.subProductDesc;
      features[index].subProductId = feature.subProductId;
      features[index].validity = feature.term;
      features[index].unitPrice = feature.price;
      features[index].discountPercentage = feature.discountPercentage;
      let totalPrice = 0.0;
      if (feature.term) {
        totalPrice = ConfigureProductActions.updateTotalPrice(
          features,
          serialsCount
        );
      }
      const validateFields = ['partNumber']; // tells what are the fileds that needs to be valiated
      const { validatedFeatures, hasErrors } = validateFeatures(
        features,
        validateFields
      );
      dispatch({
        type: ActionConstants.UPDATE_FEATURE,
        payload: {
          features: validatedFeatures,
          totalPrice,
          enableNextBtn: !hasErrors
        }
      });
    };
  }

  static updateTotalPrice(features: any, serialsCount: any) {
    let totalPrice = 0.0;
    features.forEach(feature => {
      totalPrice += feature.unitPrice * serialsCount;
    });
    return totalPrice;
  }

  static hideAspireValidationErrorMsg(show: boolean) {
    return (dispatch) => {
      dispatch({
          type: ActionConstants.SHOW_FEATURE_NOTIFICATION,
          payload: {
            showAspireErrorValidationMsg: show
          }
      });
    };
  }

  // function  to add input box
  static addNewSerial() {
    const newEmptySerialNumber = { serialNumber: '', error: '' };
    return (dispatch, getState) => {
      const previousSerials = getState().configProductData.payload
        .serialNumbers;
      const features = getState().configProductData.payload.productFeatures;
      const validations = [required, onlyDigits, minlenght(5)];
      let { validatedSerials, hasErrors } = validateSCMSerials(
        previousSerials,
        validations
      );
      let updatedSerials;
      let totalPrice = 0.0;
      if (hasErrors) {
        updatedSerials = [...validatedSerials];
      } else {
        updatedSerials = [...validatedSerials, newEmptySerialNumber];
        if (features) {
          totalPrice = ConfigureProductActions.updateTotalPrice(
            features,
            updatedSerials.length
          );
        }
      }
      dispatch({
        type: ActionConstants.ADD_NEW_SERIAL,
        payload: {
          updatedSerials,
          totalPrice,
          enableNextBtn: false
        }
      });
    };
  }

  static updateSerial(updatedSerialNumber: string, index: number) {
    // validate and update the serial number
    return (dispatch, getState) => {
      if (('' + updatedSerialNumber).length <= 5) {
        const previousSerials = getState().configProductData.payload
          .serialNumbers;
        let serials = [...previousSerials];
        serials[index].serialNumber = updatedSerialNumber;
        const validations = [required, onlyDigits];
        let { validatedSerials, hasErrors } = validateSCMSerials(
          serials,
          validations
        );
        dispatch({
          type: ActionConstants.UPDATE_SERIAL_NUMBER,
          payload: {
            validatedSerials,
            enableNextBtn: !hasErrors
          }
        });
      }
    };
  }

  /**
   * Method to validate user entered serial number on blur.
   */

  static validateSerialOnBlur() {
    return (dispatch, getState) => {
      const editProductSeq = getState().configProductData.payload
        .editCartProductDetails.productSeq;
      const previousSerials = getState().configProductData.payload
        .serialNumbers;
      const productsInCart = getState().configProductData.payload
        .productsInCart;
      const selectedProductID = getState().configProductData.payload.product
        .productId;

      let filteredCartProducts;
      if (editProductSeq) {
        // from cart page - ignoring validation for current cart line item
        filteredCartProducts = productsInCart.filter(product => {
          return (
            product.productId === selectedProductID &&
            product.productSeq !== editProductSeq
          );
        });
      } else {
        // from product listing page
        filteredCartProducts = productsInCart.filter(product => {
          return product.productId === selectedProductID;
        });
      }
      const serialArrayofArray = filteredCartProducts.map(product => {
        return product.serialNo;
      });
      let serialsInCart = [].concat.apply([], serialArrayofArray);
      const validations = [minlenght(5), presentInCart(serialsInCart)];
      let { validatedSerials, hasErrors } = validateSCMSerials(
        previousSerials,
        validations
      );
      dispatch({
        type: ActionConstants.UPDATE_SERIAL_NUMBER,
        payload: {
          validatedSerials,
          enableNextBtn: !hasErrors
        }
      });
    };
  }

  // function to delete serialNumber
  static deleteSerial(index: number) {
    return (dispatch, getState) => {
      let previousSerials = getState().configProductData.payload.serialNumbers;
      const features = getState().configProductData.payload.productFeatures;
      if (previousSerials.length > 1) {
        previousSerials.splice(index, 1);
        const validations = [required, onlyDigits];
        let { validatedSerials, hasErrors } = validateSCMSerials(
          previousSerials,
          validations
        );
        let totalPrice = 0.0;
        if (features) {
          totalPrice = ConfigureProductActions.updateTotalPrice(
            features,
            validatedSerials.length
          );
        }
        dispatch({
          type: ActionConstants.DELETE_SERIAL_NUMBER,
          payload: {
            serials: validatedSerials,
            totalPrice: totalPrice,
            enableNextBtn: !hasErrors
          }
        });
      }
    };
  }
  /**
   * Maps read excel conf data to sub products page data
   * @param subProductsList
   */
  static readConfAPIMapper(subProductsList: any) {
    // mapping features
    let productFeaturesDetails: any = [];
    if (subProductsList !== undefined) {
      subProductsList.forEach(feature => {
        productFeaturesDetails.push({
          subProductName: feature.subProductName,
          unitPrice: feature.price.toFixed(2),
          validity: feature.term,
          partNumber: feature.partNumber,
          subProductDesc: feature.subProductDesc,
          subProductId: feature.subProductId,
          discountPercentage: feature.discountPercentage


        });
      });
    }
    return productFeaturesDetails;
  }

  /**
   * Method to map serial details (array of serial numbers to array of object)
   * @param serialList
   */
  static cartSerialToProductSerialMapper(serialList: any) {
    let serialNumberList: any = [];
    if (serialList !== undefined) {
      serialList.forEach(serialElement => {
        serialNumberList.push({ serialNumber: serialElement, error: "" });
      });
    }
    return serialNumberList;
  }

  /* activeTab==1  for SCM serial Numbers
   *  activeTab==2  for configure features
   *  activeTab==3  for confirm features Tab "ADD_TO_CART" button
   *  activeTab==4 Bulk Configuration - Upload Configuration Template
   *  else edit cart
   * */
  static gotoNextTab() {
    return (dispatch, getState) => {
      let activeTab = getState().configProductData.payload.activeTab;

      if (activeTab === 1) {
        const previousSerials = getState().configProductData.payload
          .serialNumbers;
        const editProductSeq = getState().configProductData.payload
          .editCartProductDetails.productSeq;
        const productsInCart = getState().configProductData.payload
          .productsInCart;
        const selectedProductID = getState().configProductData.payload.product
          .productId;

        let filteredCartProducts;

        if (editProductSeq) {
          // from cart page - ignoring validation for current cart line item
          filteredCartProducts = productsInCart.filter(product => {
            return (
              product.productId === selectedProductID &&
              product.productSeq !== editProductSeq
            );
          });
        } else {
          // from product listing page
          filteredCartProducts = productsInCart.filter(product => {
            return product.productId === selectedProductID;
          });
        }

        const serialArrayofArray = filteredCartProducts.map(product => {
          return product.serialNo;
        });
        let serialsInCart = [].concat.apply([], serialArrayofArray);

        const validations = [
          required,
          onlyDigits,
          minlenght(5),
          presentInCart(serialsInCart)
        ];
        let { validatedSerials, hasErrors } = validateSCMSerials(
          previousSerials,
          validations
        );
        let updatedSerials = [...validatedSerials];
        if (hasErrors) {
          dispatch({
            type: ActionConstants.ADD_NEW_SERIAL,
            payload: {
              updatedSerials,
              enableNextBtn: false
            }
          });
        } else {
          const features = getState().configProductData.payload.productFeatures;
          const validateFields = ['partNumber']; // tells what are the fileds that needs to be valiated
          const { hasErrors } = validateFeatures(
              features,
              validateFields
      );
          activeTab = activeTab + 1;
          dispatch({
            type: ActionConstants.GO_TO_CONFIGURE_FEATURES,
            payload: {
              activeTab,
              enableNextBtn: !hasErrors
            }
          });
        }
      }
      // configure features tab next button
      else if (activeTab === 2) {
        const previousFeatures = getState().configProductData.payload
          .productFeatures;
        const validateFields = ['partNumber', 'validity']; // tells what are the fileds that needs to be valiated
        const { validatedFeatures, hasErrors } = validateFeatures(
          previousFeatures,
          validateFields
        );
        let newProductFeatures = [...validatedFeatures];
        if (hasErrors) {
          dispatch({
            type: ActionConstants.ADD_NEW_FEATURE,
            payload: {
              newProductFeatures,
              enableNextBtn: false
            }
          });
        } else {
          activeTab = activeTab + 1;
          dispatch({
            type: ActionConstants.GO_TO_CONFIRM_FEATURES,
            payload: {
              activeTab,
              nextbtn: 'ADD TO CART'
            }
          });
        }
      } else if (activeTab === 4) {
        // Bulk Configuration - Upload Configuration Template
        activeTab = activeTab + 1;
        let bulkError = "";
        const excelConfFile = getState().configProductData.payload
          .uploadedConfigFile;
        if (excelConfFile) {
          const productId = getState().configProductData.payload.product
            .productId;
          const soldTo = getState().selectAccount.selectAccountDetails.payload
            .soldTo.sapNumber;
          ConfigureProductAPI.readExcelConfiguration(
            productId,
            soldTo,
            excelConfFile
          )
            .then(response => {
              const subProductsList = ConfigureProductActions.readConfAPIMapper(
                response.data.subProducts
              );
              const serialNumbers = ConfigureProductActions.cartSerialToProductSerialMapper(
                response.data.serialNo
              );
              if (serialNumbers.length > 0 && subProductsList.length > 0) {
                // getting the updated total price
                const totalPrice = ConfigureProductActions.updateTotalPrice(
                  subProductsList,
                  serialNumbers.length
                );
                // setting error message
                const bulkValidationError = ConfigureProductActions.getBulkValidationErrorMessage(
                  response.data.errors
                );
                // setting the data read from api
                dispatch({
                  type: ActionConstants.SET_EXCEL_CONF_DATA,
                  payload: {
                    subProductsList,
                    serialNumbers,
                    totalPrice,
                    bulkValidationError
                  }
                });

                // redirecting to confirmation page
                dispatch({
                  type: ActionConstants.GO_TO_BULK_CONFIRM_ORDER,
                  payload: {
                    activeTab,
                    nextbtn: 'ADD TO CART'
                  }
                });
              } else {
                bulkError = 'Please upload document with proper data';
                dispatch({
                  type: ActionConstants.DISPLAY_BULK_EXCEL_ERROR,
                  payload: {
                    bulkError
                  }
                });
              }
            })
            .catch(() => {
              bulkError = 'Please upload valid document';
              dispatch({
                type: ActionConstants.DISPLAY_BULK_EXCEL_ERROR,
                payload: {
                  bulkError
                }
              });
            });
        } else {
          bulkError = 'Please upload document';

          dispatch({
            type: ActionConstants.DISPLAY_BULK_EXCEL_ERROR,
            payload: {
              bulkError
            }
          });
        }
      } else if (activeTab === 3 || activeTab === 5) {
        // In third step user click on "ADD TO CART" then this condition will be executed
        let {
          productsInCart,
          serialNumbers,
          productFeatures,
          system,
          categoryName,
          product,
          editCartProductDetails
        } = getState().configProductData.payload;
        const userID = getState().userValidationData.payload.userInfo
          .customer_sub;
        const soldTo = getState().selectAccount.selectAccountDetails.payload.soldTo.sapNumber;
        let productDetails = {
          ...product,
          system,
          categoryName,
          serialNumbers,
          subProducts: productFeatures,
          userID,
          productSeq: editCartProductDetails.productSeq,
          id: editCartProductDetails.id,
          cartSeq: editCartProductDetails.cartSeq,
          seq: editCartProductDetails.seq

        };
        productsInCart = [...productsInCart, productDetails];

        ProductAlertActions.hideAlert();

        if (!productDetails.productSeq) {
          const cartProduct = saveToCartObjMapper(productDetails,CheckoutConstants.OPERATION_TYPE_SAVE,soldTo);
          productsInCart = [...productsInCart, cartProduct];

          // SAVE TO CART
          // Showing Add to cart loader, if product is saved. No loader for edit scenario.
          // ASDS-1084
          dispatch({
            type: ActionConstants.ADD_PRODUCT_TO_CART_LOADER,
            payload: {
              addProductToCartInProgress: true,
            },
          });

          CartDetails.saveProductToCart(cartProduct, productDetails.userID).then(response => {
            let isAddToCartSuccess = false;
            if (response) {
              isAddToCartSuccess = true;
              dispatch({
                // dispatching action to add the product to CART items.
                type: ActionConstants.ADD_PRODUCT_TO_CART,
                payload: {
                  productsInCart: productsInCart
                }
              });

              dispatch(ProductAlertActions.setGenricFields(system));

              CartDetailsActions.getCartData(userID,"abstract")(dispatch, getState); // This will update the cart Count for user
            }

            // common dispatchers after save process - irespective of outcome
            dispatch({
              // dispatching action to reset the configure product data.
              type: ActionConstants.RESET_CONFIGURE_PRODUCT,
              payload: {}
            });

            dispatch({
              type: ActionConstants.OPEN_CART_ICON,
              payload: {
                openCartIcon: true
              }
            });
            dispatch({
              type: ActionConstants.CLOSE_ASPIRE_MODEL,
              payload: {}
            });

            dispatch({
              // dispatching action to update last product added to cart
              type: ActionConstants.UPDATE_LAST_PROD_CART,
              payload: {
                lastProdAddedToCart: productDetails.productName
              }
            });
            dispatch({
              type: ActionConstants.SET_ALERT_MODEL,
              payload: {
                showAlertMsg: true,
                isAddToCartSuccess: isAddToCartSuccess
              }
            });
            dispatch({
              // dispatching action to hide add to cart loader
              type: ActionConstants.ADD_PRODUCT_TO_CART_LOADER,
              payload: {
                addProductToCartInProgress: false
              }
            });

          });
        } else {
          dispatch({
            type: ActionConstants.SET_TOASTER,
            payload: {
                notify: 'bottom-right'
            }
        });
          const cartProduct = saveToCartObjMapper(productDetails, CheckoutConstants.OPERATION_TYPE_EDIT, soldTo);
          productsInCart = [...productsInCart, cartProduct];

          // EDIT CART

          dispatch({
            type: ActionConstants.EDIT_PRODUCT_TO_CART_LOADER,
            payload: {}
          });
          dispatch({
            // dispatching action to hide edit pop up
            type: ActionConstants.RESET_CONFIGURE_PRODUCT_MYCART,
            payload: {}
          });
          CartDetails.editProductToCart(cartProduct, productDetails.userID).then(response => {
            let isUpdateToCartSuccess = false;
            if (response) {
              isUpdateToCartSuccess = true;
              dispatch({
                // dispatching action to add the product to CART items.
                type: ActionConstants.ADD_PRODUCT_TO_CART,
                payload: {
                  productsInCart: productsInCart
                }
              });

              dispatch(
                // get cart products & updates cart count
                CartDetailsActions.getCartData(userID,"both")
              );

              dispatch(
                // updates order summary
                OrderSummaryActions.getOrderSummary(userID)
              );

            } else {
              dispatch(
                CartDetailsActions.showErrorOnEditProduct(product.productName)
              );
            }
            dispatch({   // dispatching action to update last product added to cart
              type: ActionConstants.UPDATE_LAST_PROD_CART,
              payload: {
                lastProdAddedToCart: productDetails.productName,
              }
            });
            dispatch({
              type: ActionConstants.SET_ALERT_MODEL,
              payload: {
                showAlertMsg: true,
                isAddToCartSuccess: isUpdateToCartSuccess
              }
            });

          }).finally(// common dispatchers after edit process - irespective of outcome
            dispatch({
              // dispatching action to reset the configure product data.
              type: ActionConstants.RESET_CONFIGURE_PRODUCT,
              payload: {}
            })
            );
        }
      }
    };
  }

  static gotoPrevTab() {
    // back button actions for the Configure Product model
    return (dispatch, getState) => {
      let activeTab = getState().configProductData.payload.activeTab;
      dispatch({
        type: ActionConstants.BACK_BUTTON_HANDLE,
        payload: {
          activeTab: activeTab - 1,
          nextbtn: 'Next',
          enableNextBtn: true
        }
      });
    };
  }

  static onClickConfigureButton(
    product: any,
    system: string,
    categoryName: string
  ) {
    // this Action will be called when user click on the "CONFIGURE" button of the product"
    return (dispatch, getState) => {
      dispatch(ProductAlertActions.hideAlert());
      let productsInCart = getState().configProductData.payload.productsInCart;
      const inCompatibleProducts = ProductAlertActions.checkInCompatibleProducts(
        productsInCart,
        categoryName
      );
      if (inCompatibleProducts.length > 0) {
        // this product is in compatible to add to cart.
        dispatch({
          type: ActionConstants.SHOW_INCOMPATIBLE_TO_ADD_TO_CART,
          payload: {
            inCompatibleProducts: true
          }
        });
      } else {
        // we can add this product to cart.
        dispatch({
          type: ActionConstants.CONFIGURE_PRODUCT_MODEL,
          payload: {
            product,
            system,
            categoryName,
            configureModelOpen: true
          }
        });

        dispatch(ProductAlertActions.setGenricFields(system));
      }
    };
  }

  /**
   * Method to redirect user to previous component. Resets component data.
   * @param currentPage
   */
  static onCancel(currentPage: any) {
    return dispatch => {
      // resetting configure product pop up data
      dispatch({
        type: ActionConstants.SET_ALERT_MODEL,
        payload: {
          showAlertMsg: false,
          isAddToCartSuccess: false
        }
      });
      dispatch({
        type: ActionConstants.RESET_CONFIGURE_PRODUCT,
        payload: {}
      });

      if (currentPage === routeConstants.MY_CART) {
        dispatch({
          type: ActionConstants.RESET_CONFIGURE_PRODUCT_MYCART,
          payload: {}
        });
      }
    };
  }

  // ASDS-1048 this will be called from OrderSummaryActions, to load cart data
  static setProductsInCart(data) {
    return dispatch => {
      dispatch({
        type: ActionConstants.LOAD_CART_DATA,
        payload: {
          productsInCart: data.result.cart.products
        }
      });
    };
  }

  static gotoSCMSerialNumbersTab() {
    return dispatch => {
      dispatch({
        type: ActionConstants.GOTO_SERIAL_NUMBERS_TAB,
        payload: {
          activeTab: CheckoutConstants.CONFIGURE_SERIAL_NUMBERS_TAB
        }
      });
    };
  }

  static gotoConfigureFeaturesTab() {
    return dispatch => {
      dispatch({
        type: ActionConstants.GOTO_CONFIGURE_FEATURES_TAB,
        payload: {
          activeTab: CheckoutConstants.CONFIGURE_FEATURES_TAB
        }
      });
    };
  }

  static gotoBulkFileUploadTab() {
    return dispatch => {
      dispatch({
        type: ActionConstants.GOTO_BULK_FILE_UPLOAD_TAB,
        payload: {
          activeTab: CheckoutConstants.BULK_FILE_UPLOAD_TAB,
          enableNextBtn: false
        }
      });
    };
  }

  /**
   * Method to traverse to other tab serial number edit section from bulk conf tab
   */
  static gotoStep1SCMSerialNumbersTab() {
    // redirecting user to tab 1
    //ConfigureProductActions.onMainTabToggle(CheckoutConstants.CONFIGURE_PRODUCT_CONFIG_TAB);
    // setting the
    return dispatch => {
      dispatch(ConfigureProductActions.onMainTabToggle(CheckoutConstants.CONFIGURE_PRODUCT_CONFIG_TAB));
      dispatch({
        type: ActionConstants.GOTO_STEP1_SERIAL_NUMBERS_TAB,
        payload: {
          activeTab: CheckoutConstants.CONFIGURE_SERIAL_NUMBERS_TAB,
          enableNextBtn: true
        }
      });
    };
  }
  /**
   * Method to traverse to other tab feature edit section from bulk conf tab
   */
  static gotoStep1ConfigureFeaturesTab() {
    // redirecting user to tab 1

    return dispatch => {
      dispatch(ConfigureProductActions.onMainTabToggle(CheckoutConstants.CONFIGURE_PRODUCT_CONFIG_TAB));
      dispatch({
        type: ActionConstants.GOTO_STEP1_CONFIGURE_FEATURES_TAB,
        payload: {
          activeTab: CheckoutConstants.CONFIGURE_FEATURES_TAB,
          enableNextBtn: true
        }
      });
    };
  }
  static onMainTabToggle(activeTabIndex) {
    return dispatch => {
      dispatch({
        type: ActionConstants.CONFIGURE_PRODUCT_MAIN_TAB_CHANGE,
        payload: {
          activeMainTabIndex: activeTabIndex,
          enableNextBtn: false
        }
      });
    };
  }

  static validateUploadedBulkConfigFile(
    uploadedFileList: File[],
    valid: boolean
  ) {
    return dispatch => {
      dispatch({
        type: ActionConstants.VALIDATE_UPLOADED_BULK_CONFIG_FILE,
        payload: {
          uploadedConfigFile:
            uploadedFileList.length > 0 && uploadedFileList[0],
          enableNextBtn: valid
        }
      });
    };
  }
  /**
   * Method to frame error message for bulk upload confirmation page
   * @param errorObj
   */
  static getBulkValidationErrorMessage(errorObj: any) {
    // errorObj ==> serialNoErrorMsg, featureErrorMsg
    let errorMessage = '';
    if (!errorObj) {
      return '';
    }
    errorMessage = 'Invalid data are ignored.';
    if (errorObj.serialNoErrorMsg) {
      errorMessage += ' Serial numbers: ' + errorObj.serialNoErrorMsg;
    }
    if (errorObj.featureErrorMsg) {
      errorMessage += ' Part numbers: ' + errorObj.featureErrorMsg;
    }
    // if default errormessage return empty
    return errorMessage === 'Invalid data are ignored.' ? '' : errorMessage;
  }

  // static hideFeatureNotification(index: number, status: boolean) {
  //   return (dispatch, getState) => {
  //     let productFeatures = getState().configProductData.payload
  //       .productFeatures;
  //     productFeatures[index].showFeatureNotification = status;
  //     dispatch({
  //       type: ActionConstants.SHOW_FEATURE_NOTIFICATION,
  //       payload: {
  //         productFeatures
  //       }
  //     });
  //   };
  // }
}

export default ConfigureProductActions;
